function sgkExpertStyleUpdates() {
    var mobileVersion = window.innerWidth < 768;

    //Bring Headers of Employees to same height.
    var employeeBoxMaxheight = {};
    $(".skgEmployeeBox .sgkEmployeeHeader").each(function () {
        $(this).innerHeight('auto');
        var pos = $(this)[0].offsetParent.offsetTop;
        var height = $(this)[0].scrollHeight;
        if (employeeBoxMaxheight[pos] === undefined || employeeBoxMaxheight[pos] < height)
            employeeBoxMaxheight[pos] = height;
    });
    $($(".skgEmployeeBox .sgkEmployeeHeader").get().reverse()).each(function () {
        $(this).innerHeight(employeeBoxMaxheight[$(this)[0].offsetParent.offsetTop]);
    });


    //set EmployeeBox to the Size of the first Employee
    if ($(".sgkdynamiccollapsecontent_collapsed .skgEmployeeBox").length > 0) {
        var employee = $(".skgEmployeeBox").first();
        var employeeContainer = employee.closest(".sgkdynamiccollapsecontent");
        var heightForemployeeContainer = employee[0].scrollHeight + employeeContainer.parent().find(".sgkReadMoreButton")[0].clientHeight;
        employeeContainer[0].style.maxHeight = heightForemployeeContainer + "px";
        employeeContainer.data("containerHeight", heightForemployeeContainer);
    }

    //set EmployeeBox to the Size of the first Expert in Region
    if ($(".sgkdynamiccollapsecontent_collapsed .skgNearbyExpertBox").length > 0) {
        var firstnearbyExpert = $(".skgNearbyExpertBox").first();
        var nearbyExpertContainer = firstnearbyExpert.closest(".sgkdynamiccollapsecontent");
        var heightFornearbyExpertContainer = firstnearbyExpert[0].scrollHeight + nearbyExpertContainer.parent().find(".sgkReadMoreButton")[0].clientHeight;
        nearbyExpertContainer[0].style.maxHeight = heightFornearbyExpertContainer + "px";
        nearbyExpertContainer.data("containerHeight", heightFornearbyExpertContainer);
    }

    if ($(".sgkdynamiccollapsecontent_collapsed.sgkExpertTextBlock").length > 0) {
        $(".sgkdynamiccollapsecontent_collapsed.sgkExpertTextBlock").each(function () {
            var height = 187;
            if (mobileVersion) {
                height = 87;
            }

            $(this)[0].style.maxHeight = height + "px";
            $(this).data("containerHeight", height);
        });

        $(".sgkdynamiccollapsecontent_container").each(function () {

            if ($(this).find(".sgkdynamiccollapsecontent_collapsed").length > 0) {
                var button = $(this).closest(".sgkdynamiccollapsecontent_container").find(".sgkdynamiccollapsebutton")[0];
                //console.log("client-height" + $(this)[0].clientHeight);
                //console.log("scroll-height" + $(this)[0].scrollHeight);

                var overflowItem = $(this)[0];
                if (mobileVersion || !overflowItem.classList.contains("h-100")) {
                    overflowItem = $(this).find(".sgkdynamiccollapsecontent")[0];
                }

                if (overflowItem.clientHeight >= overflowItem.scrollHeight) {
                    button.classList.add("d-none");
                }
                else {
                    button.classList.remove("d-none");
                }
            }
        });
    }

    $(".sgkdynamiccollapsecontent").each(function () {
        $(this)[0].classList.add("sgkdynamiccollapsecontentTransition");
    });

}

expertTypeCarousel = {
    wrapperWidth: 0,
    carouselWidth: 0,
    itemWidth: 0,
    scrollPosition: 0,
};
function initExpertTypeCarousel(ev) {
    expertTypeCarousel.wrapperWidth = $("#sgkExpertTypeCarousel").width();
    expertTypeCarousel.carouselWidth = $("#sgkExpertTypeCarousel .carousel-inner")[0].scrollWidth;
    expertTypeCarousel.itemWidth = $("#sgkExpertTypeCarousel .carousel-item").outerWidth();
    if (expertTypeCarousel.wrapperWidth < expertTypeCarousel.carouselWidth) {
        $("#sgkExpertTypeCarousel .carousel-control-next,#sgkExpertTypeCarousel .carousel-control-prev").removeClass('d-none');
    } else {
        $("#sgkExpertTypeCarousel .carousel-control-next,#sgkExpertTypeCarousel .carousel-control-prev").addClass('d-none');
    }

    // only on page load
    if (ev == null) {
        var offset = $('#sgkExpertTypeCarousel .carousel-item.active').offset();
        if (offset.left + expertTypeCarousel.itemWidth > expertTypeCarousel.wrapperWidth) {
            console.log('scrollto needed');
            var visible = Math.floor(expertTypeCarousel.wrapperWidth / expertTypeCarousel.itemWidth);
            expertTypeCarousel.scrollPosition = Math.min(expertTypeCarousel.itemWidth * $('#sgkExpertTypeCarousel .carousel-item.active').index(), expertTypeCarousel.carouselWidth - expertTypeCarousel.itemWidth * visible);
            $("#sgkExpertTypeCarousel .carousel-inner").animate(
                { scrollLeft: expertTypeCarousel.scrollPosition },
                300
            );
        }
    }
}

function validateQualificationsForm() {
    var selectedLicenseID = $('[name="cbxLicenseType"]').val();
    var selectDuration = $('[name="selectDuration"]').val();
    var tbxDateSubscriptionEnd = $('#BodyContent_tbxDateSubscriptionEnd');
    var cbxQualificationsValidationTime = $('#selectDuration');
    var fileInput = $('[name="LicenseFile"]')[0];

    if (selectedLicenseID.trim() === '') {
        alert('Bitte wählen Sie eine Lizenzart aus.');
        return false;
    }

    if (selectDuration === 'validlimited' && !tbxDateSubscriptionEnd.val()) {
        alert('Bitte wählen Sie ein Datum aus.');
        return false;
    }

    if (selectDuration === 'validlimited') {
        var currentDate = new Date();
        var selectedDate = new Date(tbxDateSubscriptionEnd.val());

        if (selectedDate <= currentDate) {
            alert('Bitte wählen Sie ein zukünftiges Datum aus.');
            return false;
        }
    }

    if (!cbxQualificationsValidationTime.val()) {
        alert('Bitte wählen Sie einen Qualifikationstyp aus.');
        return false;
    }

    if (!fileInput.files[0]) {
        alert('Bitte wählen Sie eine Datei aus.');
        return false;
    }

    var cbxUnlistedLicenseType = $('#cbxUnlistedLicenseType');
    var tbxUnlistedLicenseName = $('#tbxUnlistedLicenseName');

    if (cbxUnlistedLicenseType.is(':visible') && cbxUnlistedLicenseType.val().trim() === '') {
        alert('Bitte wählen Sie eine Lizenzart aus.');
        return false;
    }

    if (tbxUnlistedLicenseName.is(':visible') && tbxUnlistedLicenseName.val().trim() === '') {
        alert('Bitte geben Sie einen Lizenznamen ein.');
        return false;
    }

    return true;
}




$(function () {

    $(document).on("click", ".btnRefreshLicense", function () {
       
        var expertLicenseID = $(this).data("licenseid");
       
        $(".sgkQualificationsContainer").hide();
        $(".sgkRefreshQualificationsContainer").attr("data-expertLicenseID", expertLicenseID);
        $(".sgkRefreshQualificationsContainer").show();
    });

    $(document).on("click", ".btnAddUnlistedQualification", function () {
        var unlistedLicenseContainer = $("#BodyContent_cbxUnlistedLicenseType, #BodyContent_tbxUnlistedLicenseName");
        var divLicenseContainer = $("#BodyContent_divLicenseType");

        if (unlistedLicenseContainer.is(":visible")) {
            $(this).text("Weitere nicht aufgeführte Qualifikation hinzufügen");
            $("#lblUnlistedQualificationsInfoText").show();
            unlistedLicenseContainer.hide();
            divLicenseContainer.show();
            $("#licenseState").val("listed");
        } else {
            $(this).text("Aufgeführte Qualifikation hinzufügen");
            $("#lblUnlistedQualificationsInfoText").hide();
            unlistedLicenseContainer.show();
            divLicenseContainer.hide();
            $("#licenseState").val("unlisted");
        }
    });



    if ($('#sgkExpertTypeCarousel').length == 1) {
        // Hack bootstrap carousel
        initExpertTypeCarousel(null);
        window.addEventListener('resize', initExpertTypeCarousel);
        $("#sgkExpertTypeCarousel .carousel-control-next").on("click", function () {
            var visible = Math.floor(expertTypeCarousel.wrapperWidth / expertTypeCarousel.itemWidth);
            if (expertTypeCarousel.scrollPosition < expertTypeCarousel.carouselWidth - expertTypeCarousel.itemWidth * visible) {
                expertTypeCarousel.scrollPosition += expertTypeCarousel.itemWidth;
                $("#sgkExpertTypeCarousel .carousel-inner").animate(
                    { scrollLeft: expertTypeCarousel.scrollPosition },
                    300
                );
            }
        });
        $("#sgkExpertTypeCarousel .carousel-control-prev").on("click", function () {
            if (expertTypeCarousel.scrollPosition > 0) {
                expertTypeCarousel.scrollPosition -= expertTypeCarousel.itemWidth;
                $("#sgkExpertTypeCarousel .carousel-inner").animate(
                    { scrollLeft: expertTypeCarousel.scrollPosition },
                    300
                );
            }
        });
    }

    if ($('.sgkSelectEdit').length > 0) {
        $('.sgkSelectEdit').each(function () {
            $(this).select2({
                tags: !$(this).data("static"),
                debug: true,
                width: '100%',
                language: "de",
                //placeholder: "Bitte auswählen",
                //allowClear: true
            });
        });
    }

    if ($('.sgkSelectFilterEdit').length > 0) {
        $('.sgkSelectFilterEdit').select2({
            width: '100%',
            placeholder: "Bitte Filter auswählen",
        });
    }

    if ($('.sgkProfileEdit').length > 0) {
        sgkInitProfileTinyMCE($('.sgkProfileEdit'));
    }

    if ($('.sgkInfoboxEdit').length > 0) {
        sgkInitInfoboxTinyMCE($('.sgkInfoboxEdit'));
    }


    $(document).ready(function () {
        //Not Proud of this, there must be another way
        window.addEventListener('resize', sgkExpertStyleUpdates);
        sgkExpertStyleUpdates();
    });

    $(document).on("click", ".btnTransferBankFile", function () {
        var obj = $(this).closest("div").find(".alert");
        obj.toggleClass("d-none");
    });


    $(document).on("click", ".sgkBtnSeach", function () {
        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "/apotheken/suche",
            data: JSON.stringify({
                action: "testSeach",
                expertid: 1234,
            }),
            dataType: 'json',
            success: function (data) {
                button.removeClass("d-none");
                container.find(".sgkSavedInfo").removeClass("d-none");
                container.find(".spinner-border").addClass("d-none");
            }
        });
    });

    $('.sgkExpertCardAccordion').click(function () {
        $(this).find(".row.body").toggleClass("accordionExpanded");
        $(this).find(".fa-arrow-right").toggleClass("accordionExpanded");
    });


    $('.sgkreadMoreDynamicSize').click(function () {
        var buttonHeight = $(this).parent().outerHeight(true) - 1;
        var card = $(this).closest('.sgkFlatCard');


        card.height(card.height());
        card.toggleClass('position-absolute position-relative');
        //card.toggleClass('h-100');

        var oldHeight = card.css("min-height");
        var requiredHeight = card.find('.sgkFlatCardContent').outerHeight(true) + buttonHeight + 'px';
        if (oldHeight !== '0px') {
            card.height(requiredHeight);

            card.css('min-height', '0px');
        }
        else {

            card.height(card.parent().height);
        }

        card.css('height', requiredHeight);

        if ($(this)[0].innerHTML === '<i class="fas fa-plus mr-1 p-1"></i>Mehr anzeigen') {
            $(this)[0].innerHTML = '<i class="fas fa-minus mr-1 p-1"></i>Weniger anzeigen';
        } else {
            $(this)[0].innerHTML = '<i class="fas fa-plus mr-1 p-1"></i>Mehr anzeigen';
        }
        return false;
    });

    $('.sgkExpertCardMore').each(function () {
        var body = $(this).closest(".col").find("> .body");
        if (body.length > 0) {
            var height = body[0].scrollHeight;
            var logo = body.find("img");
            if (logo.length > 0) {
                body.css("max-height", logo.height() + "px");
                //body.css("margin-bottom", "15px");
                logo.on('load', function () {
                    body.css("max-height", logo.height() + "px");
                });
                //console.log("height: " + height);
                //console.log("outerheight: " + (body.outerHeight() + 1));
            }
            if (height > body.outerHeight() + 1) {

                body.css("margin-bottom", "0");
                $(this).closest(".more").show();
                $(this).click(function () {
                    var i = $(this).find('i').toggleClass('fa-minus fa-plus');
                    $(this).closest('.sgkExpertCard').toggleClass('body-more body-expand');
                    $(this).contents().filter(function () {
                        return this.nodeType == 3;
                    }).replaceWith($(this).data('show' + (i.hasClass('fa-minus') ? 'less' : 'more') + 'text'));
                    return false;
                })
            }
        }
    })

    $('.sgkExpertQualificationsMore').each(function () {
        var ul = $(this).parents('.sgkAtAGlance').find('.sgkLicenses');
        //console.log(ul);
        if (ul.length > 0) {
            var height = ul[0].scrollHeight;
            if (height > 160) {
                ul.css("max-height", "160px");
            }
            if (height > ul.outerHeight() + 1) {
                $(this).closest(".more").show();
                $(this).click(function () {
                    var i = $(this).find('i').toggleClass('fa-minus fa-plus');
                    $(this).parents('.sgkAtAGlance').find('.sgkLicenses').toggleClass('body-expand');
                    $(this).contents().filter(function () {
                        return this.nodeType == 3;
                    }).replaceWith($(this).data('show' + (i.hasClass('fa-minus') ? 'less' : 'more') + 'text'));
                    return false;
                })
            }
        }
    });

    $(".jsModalCarouselOpen").click(function () {
        if (!$("#d-md").is(":visible")) {
            $(".jsModalCarouselLink").click();
        }
    })

    $('.sgkExpertCard.body-collapsed').click(function () {
        var card = $(this);
        if (!card.find('.body').is(":visible") || (!$("#d-md").is(":visible") && card.hasClass("sgkExpertCardAbout"))) {
            if (!card.hasClass("sgkModal")) {
                $("#sgkExpertModal").find('.modal-title').text(card.find('.title').text());
                $("#sgkExpertModal").find('.modal-body').html(card.find('.body').prop('outerHTML'));
                $("#sgkExpertModal").find('.modal-body').find("> .row > div > .p-2").removeClass("p-2");
                if ($("#sgkExpertModal").find('.modal-body > .row')[0] != undefined)
                    $("#sgkExpertModal").find('.modal-body > .row')[0].style.maxHeight = 'none'
                $("#sgkExpertModal").modal('show');
            }
        }

    })
    if ($('.tbx-time').length > 0) {
        $('.tbx-time').mask('00:00', { placeholder: "__:__" });
    }

    $('.sgkdynamiccollapsebutton').click(function () {
        var minusIcon = '<i class="fas fa-minus mr-1 p-1"></i>';
        var plusIcon = '<i class="fas fa-plus mr-1 p-1"></i>';


        var content = $(this).closest(".sgkdynamiccollapsecontent_container").find(".sgkdynamiccollapsecontent");
        content.toggleClass("sgkdynamiccollapsecontent_collapsed");
        content = content;
        if (content[0].classList.contains("sgkdynamiccollapsecontent_collapsed")) {
            if (content.data("containerHeight") !== undefined) {//containerHeight is the Minheight of the Container
                content[0].style.maxHeight = content.data("containerHeight") + "px";
            }
            else {
                content[0].style.maxHeight = null;
            }

            $(this)[0].innerHTML = plusIcon + $(this).data("showmoretext");


            var el = $(this).closest(".sgkdynamiccollapsecontent_container")[0];
            var containerPosition = 0;
            while (el !== null && (el.tagName || '').toLowerCase() !== 'html') {
                containerPosition += el.offsetTop || 0;
                el = el.offsetParent;
            }
            containerPosition -= $("#sgkHeader")[0].clientHeight;
            if (containerPosition < window.scrollY)
                window.scrollTo({ top: containerPosition, behavior: 'smooth' });
        }
        else {
            //Set to 9999px because otherwise the annimation would not start
            content[0].style.maxHeight = content[0].scrollHeight + $(this).parent()[0].clientHeight + "px";
            $(this)[0].innerHTML = minusIcon + $(this).data("showlesstext");
        }

        return false;
    });

    $('.sgkreadMore').click(function () {
        var buttonHeight = $(this).parent()[0].clientHeight - 1;
        var card = $(this).closest('.sgkFlatCard');

        var oldHeight = card.css("min-height");
        var requiredHeight = card.find('.sgkFlatCardContent')[0].clientHeight + buttonHeight + 'px';
        if (oldHeight !== '0px') {
            requiredHeight = oldHeight;
            card.css('min-height', '0px');
        }
        else {
            card.css('min-height', card.css("height"));
        }


        card.css('height', requiredHeight);

        if ($(this)[0].innerHTML === '<i class="fas fa-plus mr-1 p-1"></i>Mehr anzeigen') {
            $(this)[0].innerHTML = '<i class="fas fa-minus mr-1 p-1"></i>Weniger anzeigen';
        } else {
            $(this)[0].innerHTML = '<i class="fas fa-plus mr-1 p-1"></i>Mehr anzeigen';
        }
        return false;
    });


    $('.sgkExpertFormDataInvoiceToggle').click(function () {
        $('.sgkExpertFormDataInvoice').toggleClass('d-none');
    });

    $(document).on("click", ".btnSendMessageToExpert", function () {
        $(this).closest(".sgkExpertDetail").find(".sgkModalSendMessageToExpert").modal("show");
    });

    $(document).on("click", ".btnExpertSearch,.btnExpertSearchMap", function (e) {
        //fbq('track', 'Search');
        var expertType = $(this).closest(".row").find(".js-expertTypes");

        if (expertType.length > 0 && isNaN(expertType.val())) {
            expertType.addClass("is-invalid");
            return false;
        }


        //probably has to be changed with new Design:
        $(this).closest(".sgkSearchCard").find(".sgkFixedFilterCheckbox").each(function (e) {
            if ($(this).find("input").attr("value") == "true" && typeof (gtag) != 'undefined') {
                gtag('event', 'Filter', { 'event_category': $(this).find("input").data("eventcategory") });
            }
        });

        $(this).closest(".sgkSearchCard").find(".sgkcbxFilter").each(function (e) {
            if ($(this)[0].checked && typeof (gtag) != 'undefined') {
                gtag('event', 'Filter', { 'event_category': $(this).data("eventcategory") });
            }
        });

        if (typeof (gtag) != 'undefined') {
            gtag('event', 'conversion', { 'send_to': 'AW-710251244/wvlVCL2ZvqoBEOyl1tIC' });
        }
        sessionStorage.setItem('alreadyShowedInfo', 'false');
    });

    $(document).on('click', '.sgkMiniSearch .btn', function () {
        return submitMiniSearch($(this).parents('.sgkMiniSearch'));
    });
    $(document).on('keydown', '.sgkMiniSearch input[type="text"]', function (event) {
        if (event.keyCode == 13) { return submitMiniSearch($(this).parents('.sgkMiniSearch')); }
    });

    $(document).on('change', 'select.js-expertTypes', function (event) {
        $('select.sgkSelectSearch').val('Alle');
    });


    $(document).on("click", ".sgkbtnExpertProfile", function () {
        gtag('event', 'Klick', { 'event_category': 'Mehr erfahren', 'event_label': $(this).data("expertid") });
    });


    $(document).on("click", ".sgkgtagEvent", function () {
        // console.log("Category: " + $(this).data("eventcategory") + " ExpertID " + $(this).data("expertid"));
        gtag('event', 'Klick', { 'event_category': $(this).data("eventcategory"), 'event_label': $(this).data("expertid") });
    });


    // sgkgtagEvent" data-eventcategory="Adresse" data-expertid="<%# Expert?.ExpertID %>"

    //$(document).on("click", ".btnExpertRegisterCompletion", function () {
    //    //fbq('track', 'CompleteRegistration');
    //    // gtag('event', 'conversion', { 'send_to': 'AW-710251244/wvlVCL2ZvqoBEOyl1tIC' });
    //});

    $(document).ready(function () {
        var message = $(this).find('.sgkModalInfoMessage');

        if (message.length === 1 && sessionStorage.getItem('alreadyShowedInfo') !== 'true' && window.location.href.indexOf("naturheilkunde") > -1) {
            message.modal('show');
            sessionStorage.setItem('alreadyShowedInfo', 'true');
        }
    });

    $(document).on("click", ".sgkbtnModalSendMessageToExpertClose", function () {
        $(this).closest(".sgkModalSendMessageToExpert").modal("hide");
    });

    $(document).on("click", ".sgkbtnModalSendMessageToExpert", function () {
        var data = new FormData();
        var contactForm = $(this).closest(".sgkModalSendMessageToExpert");
        data.append("action", "contactMessageExpert");
        data.append("expertID", contactForm.data("expertid"));


        var contactNameForm = contactForm.find(".sgkContactName");
        var contactEmailForm = contactForm.find(".sgkContactEmail");
        var contactPhoneFrom = contactForm.find(".sgkContactPhone");
        var contactMessageForm = contactForm.find(".sgkContactMessage");

        data.append("name", contactNameForm.val());
        data.append("email", contactEmailForm.val());
        data.append("phone", contactPhoneFrom.val());
        data.append("message", contactMessageForm.val());


        if ((/(.+)@(.+){2,}\.(.+){2,}/.test(contactEmailForm.val())) == false) {
            alert("Bitte gültige Email angeben.");
            return;
        }

        var modal = $(this).closest(".sgkModalSendMessageToExpert");

        $.ajax({
            url: "/Handler/Email.ashx",
            type: 'POST',
            data: data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function (data, textStatus, jqXHR) {
                if (data.error === false) {
                    alert("Nachricht erfolgreich verschickt.");
                }
                else {
                    alert("Fehler beim verschicken der Nachricht.");
                }

                modal.modal("hide");
                contactNameForm.val('');
                contactEmailForm.val('');
                contactPhoneFrom.val('');
                contactMessageForm.val('');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // Handle errors here
                // STOP LOADING SPINNER
            }
        });

    });


    $(document).on("click", ".sgkbtnStartResetPassword", function () {
        $(this).closest(".sgkProfileInformation").find(".sgkModalResetPassword").modal("show");
        return false;
    });

    $(document).on("click", ".sgkbtnResetPasswordClose", function () {

        $(this).closest(".sgkModalResetPassword").modal("hide");
        return false;

    });

    var submitted = false;
    $(document).on("click", ".sgk-btnSave", function () {
        submitted = true;
    });

    if (window.location.href.toLowerCase().includes("konto/")) {
        window.onbeforeunload = function (e) {
            if (!submitted) {
                var hasUnsavedValue = false;
                $('select.sgkUnsavedValue, textarea.sgkUnsavedValue, input.sgkUnsavedValue, span.sgkUnsavedValue input').each(function () {
                    if (($(this).attr("type") === "checkbox" || $(this).attr("type") === "radio") &&
                        $(this).is(":checked") !== ($(this).parent().data("unsavedvalue") === "True")) {
                        //console.log("Some checkbox got changed");
                        //console.log("ID:" + $(this).attr("id"));
                        hasUnsavedValue = true;
                        return false;
                    }
                    else if ($(this).data("unsavedvalue") !== undefined &&
                        $(this).val() !== $(this).data("unsavedvalue").toString()) {
                        //console.log("Some input got changed");
                        //console.log("New Value:" + $(this).val());
                        //console.log("Old Value:" + $(this).data("unsavedvalue"));
                        //console.log("Type:" + $(this).attr("type"));
                        //console.log("ID:" + $(this).attr("id"));
                        hasUnsavedValue = true;
                        return false;
                    }
                });

                if (hasUnsavedValue) {
                    var message = "Sie haben noch ungespeicherte Daten.";
                    e = e || window.event;
                    // For IE and Firefox
                    if (e) {
                        e.returnValue = message;
                    }
                    // For Safari
                    return message;
                }
            }
        };
    }

    $(document).on("change", ".cbxQualificationsValidationTime", function () {

        var dateSelector = $(this).closest(".sgkQualificationsContainer").find(".sgkQualificationDateSelectorContainer");
        if ($(this).val() == "validlimited") {
            dateSelector.removeClass("d-none");
        }
        else {
            dateSelector.addClass("d-none");
        }
    });




    var popoverTriggerList = [].slice.call(document.querySelectorAll('.skgExpertPopover'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {

        return new bootstrap.Popover(popoverTriggerEl, {
            html = true,
            animation: true,
            trigger: "focus",
            placement: "bottom",
            content = function () {
                // console.log($(this).parent().find(".skgExpertPopoverContent").html());
                return $(this).parent().find(".skgExpertPopoverContent").html()
            }
        });
    })


    $(".sgkcbxAccountSelector").on("change", function (e) {



        var expertDetail = $(this).data("expertdetail");





        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "/Handler/ExpertHandler.ashx",
            data: JSON.stringify({
                action: "changeCurrentLogin",
                expertid: event.target.value,
            }),
            dataType: 'json',
            success: function (data) {
                if (expertDetail == "True") {
                    document.location.href = data.experturl;
                }
                else
                    document.location.reload(true);
            }
        });

    });


});

function sgkInitProfileTinyMCE(content, size) {
    if (typeof size === "undefined") {
        size = "normal";
    }

    content.tinymce({
        script_url: '/Scripts/tinymce/tinymce.min.js',
        height: 500,
        force_p_newlines: true,
        menubar: false,
        branding: false,
        toolbar1: 'bold',
        elementpath: false,
        plugins: "paste",
        paste_as_text: true,
        paste_block_drop: true,
        content_style:
            "@import url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;500;600&display=swap'); body {color:#495057; font-size:1.2rem; font-family: 'Fira Sans',sans-serif; }",
    });
}

function submitMiniSearch(ref) {
    var data = { search: ref.find('input[type="text"]').val(), experttype: ref.find('.btn').data('experttype') };
    $.post('/Handler/MiniSearch.ashx',
        data,
        function (res) {
            document.location = res;
        }
    );

    return false;
}